export enum AircraftImageTypeEnum {
  INTERIOR = 'INTERIOR',
  EXTERIOR = 'EXTERIOR',
  FLOORPLAN = 'FLOORPLAN',
}
